import { useMemo } from "react";
import { observer } from "mobx-react-lite";
import { SelectField } from "@/components/common";
import { useTran } from "@/hooks";
import { useDisclosureStore } from "../../hooks/useDataEntryStore";
import { reportingYearStore } from "@/features/reporting-boundary/stores/reporting-year.store";
import { mapYearToReportingPeriod } from "@/features/esg/utils/period-constants";

/**
 * Year filter — single select. Year options derive from
 * `disclosureStore.disclosures.masterDataYears` (i.e., the years that have at
 * least one master-data assignment). The empty-value label is configurable
 * via `placeholder` so callers can express "All Years" (optional) vs
 * "Select year…" (required).
 */
const ALL = "__all__";

const YearFilter = observer(({ value, onChange, placeholder, label }) => {
  const { t } = useTran();
  const { disclosures } = useDisclosureStore();

  const { reportingYears } = reportingYearStore;

  // const options = useMemo(() => {
  //   const years = [
  //     ...new Set(disclosures.flatMap((d) => d.masterDataYears || [])),
  //   ].sort((a, b) => b - a);
  //   return [
  //     { value: ALL, label: placeholder || t("All Years") },
  //     ...years.map((y) => ({ value: String(y), label: formatYear(y) })),
  //   ];
  // }, [disclosures, placeholder, t]);

  const options = useMemo(() => {
    const years = [
      ...new Set(disclosures.flatMap((d) => d.masterDataYears || [])),
    ].sort((a, b) => b - a);

    return [
      { value: ALL, label: placeholder || t("All Years") },
      ...years.map((year) => ({
        value: String(year),
        label: mapYearToReportingPeriod(reportingYears, year),
      })),
    ];
  }, [disclosures, reportingYears, placeholder, t]);

  return (
    <SelectField
      label={label || t("Reporting Year")}
      options={options}
      value={value || ALL}
      onValueChange={(v) => onChange(v === ALL ? "" : v)}
      sortOptions={false}
      placeholder={placeholder || t("All Years")}
      className="w-full sm:w-40"
      contentClassName="w-max min-w-[var(--radix-popover-trigger-width,var(--radix-select-trigger-width))] max-w-[calc(100vw-1rem)] [&_[data-slot=searchable-select-label]]:overflow-visible [&_[data-slot=searchable-select-label]]:whitespace-nowrap"
    />
  );
});

export default YearFilter;
